import React from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  GridItem,
  Flex,
  Heading,
  Image,
  TextLink,
} from '@feast-it/pesto';
import { useInView } from 'react-intersection-observer';

import Link from '../../components/Link';

import * as Styled from './styles';

const ImageAndCopy = ({
  isImageLeft,
  image,
  title,
  ctaLink,
  ctaText,
  ctaAs,
  text,
}) => {
  const [ref, inView] = useInView({
    threshold: 0,
    triggerOnce: true,
  });

  return (
    <Grid
      gridTemplateColumns={{ m: 'repeat(12, 1fr)' }}
      gridColumnGap={{ _: 'gutter._', m: 'gutter.m' }}
      gridRowGap={5}
    >
      <GridItem
        gridColumn={
          isImageLeft
            ? { m: '1 / span 6', l: '1 / span 5' }
            : { m: '7 / span 6', l: '8 / span 5' }
        }
        ml={isImageLeft ? null : { l: -9 }}
        mr={isImageLeft ? { l: -9 } : null}
      >
        <div ref={ref}>
          <Image src={image} width={700} height={400} inView={inView} imgix />
        </div>
      </GridItem>

      <GridItem
        gridRow={{ m: '1' }}
        gridColumn={
          isImageLeft
            ? { m: '7 / span 6', l: '7 / span 5' }
            : { m: '1 / span 6', l: '2 / span 5' }
        }
      >
        <Flex flexDirection="column" justifyContent="center" height="100%">
          <Heading
            as="h2"
            variant={{
              _: 'headingExtraLargeMobile',
              m: 'headingExtraLarge',
            }}
            color="blueDark"
            mb={5}
          >
            {title}
          </Heading>

          <Styled.Text>
            {text}

            {ctaLink && ctaText && (
              <>
                {' '}
                <TextLink
                  href={ctaLink}
                  as={ctaAs}
                  color="primary"
                  fontWeight="bold"
                  arrow="right"
                  linkComponent={Link}
                >
                  {ctaText}
                </TextLink>
              </>
            )}
          </Styled.Text>
        </Flex>
      </GridItem>
    </Grid>
  );
};

ImageAndCopy.propTypes = {
  isImageLeft: PropTypes.bool,
  image: PropTypes.string.isRequired,
  text: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  title: PropTypes.string.isRequired,
  ctaLink: PropTypes.string,
  ctaAs: PropTypes.string,
  ctaText: PropTypes.string,
};

export default ImageAndCopy;
